if (!customElements.get('nc-catalog-product')) {
  customElements.define('nc-catalog-product', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.quantity = this.querySelector('[data-quantity]');
      this.form = this.querySelector('form');
      this.gallery = this.querySelector('[data-gallery]');
      this.track = this.querySelector('[data-ingredient-track]');
      this.sticky = this.querySelector('[data-sticky]');
      if (!this.quantity || !this.form || !this.gallery || !this.track) return;
      this.querySelectorAll('.ns-faq summary').forEach(summary=>{if(!summary.querySelector('span')){const icon=document.createElement('span');icon.setAttribute('aria-hidden','true');summary.append(icon);}});
      this.initPurchase();
      this.initDocuments(options);
      const slides = [...this.gallery.children];
      let current = 0;
      const showSlide = index => {
        const slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
        this.gallery.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft });
      };
      const updateGallery = () => {
        current = slides.reduce((best, slide, index) => Math.abs(slide.offsetLeft - slides[0].offsetLeft - this.gallery.scrollLeft) < Math.abs(slides[best].offsetLeft - slides[0].offsetLeft - this.gallery.scrollLeft) ? index : best, 0);
      };
      this.gallery.addEventListener('scroll', updateGallery, { ...options, passive: true });
      this.gallery.addEventListener('keydown', event => {
        if (event.target !== this.gallery || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        showSlide(current + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      updateGallery();
      this.querySelector('[data-ingredient-controls]').hidden = false;
      const moveIngredients = direction => this.track.scrollBy({ left: direction * (this.track.firstElementChild.getBoundingClientRect().width + 16) });
      this.querySelector('[data-ingredient-prev]').addEventListener('click', () => moveIngredients(-1), options);
      this.querySelector('[data-ingredient-next]').addEventListener('click', () => moveIngredients(1), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        moveIngredients(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      const updateIngredients = () => {
        this.querySelector('[data-ingredient-prev]').disabled = this.track.scrollLeft <= 1;
        this.querySelector('[data-ingredient-next]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      this.track.addEventListener('scroll', updateIngredients, { ...options, passive: true });
      const ingredientIntros = ['erojan', 'tmk', 'imuglo', 'homega', 'spi2ro-plus'].includes(this.dataset.handle)
        ? [...this.track.querySelectorAll('.ns-ingredient > div:first-child')] : [];
      let ingredientIntroWidth = 0;
      const alignIngredientIntros = () => {
        if (!ingredientIntros.length) return;
        const width = ingredientIntros[0].getBoundingClientRect().width;
        if (!width || width === ingredientIntroWidth) return;
        ingredientIntroWidth = width;
        ingredientIntros.forEach(intro => { intro.style.minHeight = ''; });
        const height = Math.ceil(Math.max(...ingredientIntros.map(intro => intro.getBoundingClientRect().height)));
        ingredientIntros.forEach(intro => { intro.style.minHeight = height + 'px'; });
      };
      const refreshIngredientFonts = () => {
        if (options.signal.aborted) return;
        ingredientIntroWidth = 0;
        alignIngredientIntros();
      };
      alignIngredientIntros();
      if (ingredientIntros.length && document.fonts) {
        document.fonts.ready.then(refreshIngredientFonts);
        document.fonts.addEventListener('loadingdone', refreshIngredientFonts, options);
      }
      this.resizeObserver = new ResizeObserver(() => { alignIngredientIntros(); updateIngredients(); updateGallery(); });
      this.resizeObserver.observe(this.track);
      this.resizeObserver.observe(this.gallery);
      const purchaseButton = this.form.querySelector('.ns-add');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.sticky.hidden = false;
      this.updateSticky = () => {
        if (this.stickyFrame) return;
        this.stickyFrame = requestAnimationFrame(() => {
          const visible = purchaseButton.getBoundingClientRect().bottom <= 0;
          this.sticky.classList.toggle('is-visible', visible);
          this.sticky.setAttribute('aria-hidden', String(!visible));
          this.sticky.inert = !visible;
          this.stickyFrame = null;
        });
      };
      this.querySelectorAll('[data-sticky-buy]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        (this.querySelector('[data-pairs]:not([hidden]) select') || this.quantity).focus({ preventScroll: true });
        this.form.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth', block: 'start' });
      }, options));
      window.addEventListener('scroll', this.updateSticky, { ...options, passive: true });
      window.addEventListener('resize', this.updateSticky, options);
      this.stickyResizeObserver = new ResizeObserver(this.updateSticky);
      this.stickyResizeObserver.observe(this.form);
      this.updateSticky();
      this.initResearch(options);
      this.initComparison(options);
      this.initBenefitTimeline(options);
      this.initStory(options);
      this.initPack(options);
      this.initBundle(options);
    }
    initComparison(options) {
      const scroll = this.querySelector('[data-compare-scroll]');
      const bar = this.querySelector('[data-compare-scrollbar]');
      if (!scroll || !bar) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        const max = scroll.scrollWidth - scroll.clientWidth;
        bar.hidden = max <= 1;
        scroll.style.cursor = max > 1 ? '' : 'auto';
        if (max <= 1) return;
        const thumb = bar.clientWidth * scroll.clientWidth / scroll.scrollWidth;
        bar.style.setProperty('--ns-scroll-thumb', `${thumb}px`);
        bar.style.setProperty('--ns-scroll-offset', `${(bar.clientWidth - thumb) * Math.max(0, Math.min(1, scroll.scrollLeft / max))}px`);
      };
      scroll.addEventListener('scroll', update, { ...options, passive: true });
      scroll.addEventListener('keydown', event => {
        if (event.target !== scroll || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const left = event.key === 'Home' ? 0 : event.key === 'End' ? scroll.scrollWidth : scroll.scrollLeft + (event.key === 'ArrowRight' ? 1 : -1) * scroll.clientWidth * .65;
        scroll.scrollTo({ left, behavior: motion.matches ? 'auto' : 'smooth' });
      }, options);
      let drag = null;
      scroll.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || scroll.scrollWidth <= scroll.clientWidth) return;
        drag = { id: event.pointerId, x: event.clientX, left: scroll.scrollLeft };
        scroll.setPointerCapture(event.pointerId);
      }, options);
      scroll.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const delta = event.clientX - drag.x;
        if (Math.abs(delta) > 4) scroll.classList.add('is-dragging');
        scroll.scrollLeft = drag.left - delta;
      }, options);
      const finish = () => { drag = null; scroll.classList.remove('is-dragging'); };
      scroll.addEventListener('pointerup', finish, options);
      scroll.addEventListener('pointercancel', finish, options);
      scroll.addEventListener('lostpointercapture', finish, options);
      this.compareResizeObserver = new ResizeObserver(update);
      this.compareResizeObserver.observe(scroll);
      this.compareResizeObserver.observe(scroll.firstElementChild);
      update();
    }
    initBenefitTimeline(options) {
      const timeline = this.querySelector('[data-benefit-timeline]');
      if (!timeline) return;
      const track = timeline.querySelector('.ns-benefit-steps');
      const steps = [...track.children];
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const paint = () => {
        this.benefitFrame = null;
        if (!timeline.isConnected) return;
        const top = track.getBoundingClientRect().top + 14;
        const last = steps[steps.length - 1].getBoundingClientRect().top + 14;
        const length = Math.max(0, last - top);
        const threshold = window.innerHeight * .72;
        track.style.setProperty('--ns-benefit-length', `${length}px`);
        track.style.setProperty('--ns-benefit-progress', `${motion.matches ? length : Math.max(0, Math.min(length, threshold - top))}px`);
        steps.forEach(step => {
          const distance = threshold - step.getBoundingClientRect().top;
          const opacity = motion.matches ? 1 : .28 + .72 * Math.max(0, Math.min(1, distance / 100));
          step.style.setProperty('--ns-benefit-opacity', opacity.toFixed(3));
        });
      };
      const update = () => {
        if (this.benefitFrame == null) this.benefitFrame = requestAnimationFrame(paint);
      };
      timeline.classList.add('ns-benefit-timeline-enhanced');
      window.addEventListener('scroll', update, { ...options, passive: true });
      window.addEventListener('resize', update, options);
      motion.addEventListener('change', update, options);
      this.benefitResizeObserver = new ResizeObserver(update);
      this.benefitResizeObserver.observe(track);
      paint();
    }
    initBundle(options) {
      const bundle = this.querySelector('.ns-seed-bundle');
      if (!bundle) return;
      const products = [...bundle.querySelectorAll('.ns-bundle-product')];
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const clamp = value => Math.max(0, Math.min(1, value));
      const paint = () => {
        this.bundleFrame = null;
        if (!bundle.isConnected) return;
        const rect = bundle.getBoundingClientRect();
        const height = window.innerHeight;
        const progress = motion.matches ? 1 : clamp((height * .9 - rect.top) / (height * .55));
        const inset = 16 * (1 - progress);
        bundle.style.setProperty('--ns-bundle-scale', String(1 - inset * 2 / Math.max(1, rect.width)));
        bundle.style.setProperty('--ns-bundle-radius', `${32 * (1 - progress)}px`);
        products.forEach(product => {
          const reveal = motion.matches ? 1 : clamp((height * .93 - product.getBoundingClientRect().top) / (height * .24));
          product.style.setProperty('--ns-product-reveal', reveal.toFixed(3));
          product.style.setProperty('--ns-label-y', `${8 * (1 - reveal)}px`);
          product.style.setProperty('--ns-image-y', `${18 * (1 - reveal)}px`);
          product.style.setProperty('--ns-image-opacity', String(.5 + reveal * .5));
        });
      };
      const update = () => {
        if (this.bundleFrame == null) this.bundleFrame = requestAnimationFrame(paint);
      };
      window.addEventListener('scroll', update, { ...options, passive: true });
      window.addEventListener('resize', update, options);
      motion.addEventListener('change', update, options);
      this.bundleResizeObserver = new ResizeObserver(update);
      this.bundleResizeObserver.observe(bundle);
      products.forEach(product => this.bundleResizeObserver.observe(product));
      paint();
      bundle.classList.add('ns-bundle-scroll-motion');
    }
    initPack(options) {
      const card = this.querySelector('.ns-pack-card');
      const pack = card?.querySelector('[data-pack-interact]');
      const photo = pack?.querySelector('img');
      if (!card || !pack || !photo) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      let inView = false;
      let played = false;
      const resetTilt = () => {
        pack.style.removeProperty('--ns-pack-x');
        pack.style.removeProperty('--ns-pack-y');
      };
      const stop = () => {
        clearTimeout(this.packAutoTimer);
        this.packAutoTimer = null;
        this.packShake?.cancel();
        resetTilt();
      };
      const scheduleShake = () => {
        if (played || this.packAutoTimer != null || !inView || motion.matches || document.hidden || !photo.complete || !photo.naturalWidth) return;
        this.packAutoTimer = setTimeout(() => {
          this.packAutoTimer = null;
          if (!inView || motion.matches || document.hidden) return;
          played = true;
          this.packShake = photo.animate([
            { transform: 'translateY(0) rotate(0deg)' },
            { transform: 'translateY(-7px) rotate(-7deg)' },
            { transform: 'translateY(-4px) rotate(7deg)' },
            { transform: 'translateY(-6px) rotate(-5deg)' },
            { transform: 'translateY(-3px) rotate(4deg)' },
            { transform: 'translateY(0) rotate(0deg)' }
          ], { duration: 2800, easing: 'ease-in-out' });
        }, 1400);
      };
      const updateMotion = () => {
        if (motion.matches) {
          stop();
          card.classList.remove('ns-pack-motion');
          card.classList.add('ns-pack-visible');
        } else scheduleShake();
      };
      if ('IntersectionObserver' in window) {
        if (!motion.matches) card.classList.add('ns-pack-motion');
        this.packObserver = new IntersectionObserver(entries => {
          const entry = entries[entries.length - 1];
          if (entry.intersectionRatio >= 0.6) inView = true;
          else if (!entry.isIntersecting || entry.intersectionRatio < 0.15) inView = false;
          if (inView) {
            card.classList.add('ns-pack-visible');
            scheduleShake();
          } else {
            stop();
            played = false;
          }
        }, { threshold: [0, 0.15, 0.6] });
        this.packObserver.observe(pack);
      }
      updateMotion();
      motion.addEventListener('change', updateMotion, options);
      photo.addEventListener('load', scheduleShake, options);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : scheduleShake(), options);
      pack.addEventListener('pointermove', event => {
        if (motion.matches || !hover.matches || event.pointerType !== 'mouse') return;
        const bounds = pack.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, (event.clientX - bounds.left) / bounds.width * 2 - 1));
        const y = Math.max(-1, Math.min(1, (event.clientY - bounds.top) / bounds.height * 2 - 1));
        pack.style.setProperty('--ns-pack-x', (-y * 5).toFixed(2) + 'deg');
        pack.style.setProperty('--ns-pack-y', (x * 7).toFixed(2) + 'deg');
      }, options);
      pack.addEventListener('pointerleave', resetTilt, options);
    }
    initStory(options) {
      const track = this.querySelector('[data-story-track]');
      if (!track) return;
      const cards = [...track.children];
      const dots = [...this.querySelectorAll('[data-story-dot]')];
      const controls = this.querySelector('[data-story-controls]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0;
      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 2;
        controls.hidden = !overflow;
        track.tabIndex = overflow ? 0 : -1;
        current = cards.reduce((best, card, i) => Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft) < Math.abs(cards[best].offsetLeft - cards[0].offsetLeft - track.scrollLeft) ? i : best, 0);
        dots.forEach((dot, i) => i === current ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
      };
      const show = index => {
        const card = cards[Math.max(0, Math.min(cards.length - 1, index))];
        track.scrollTo({ left: card.offsetLeft - cards[0].offsetLeft, behavior: motion.matches ? 'instant' : 'smooth' });
      };
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i), options));
      track.addEventListener('scroll', update, { ...options, passive: true });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        show(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.storyResizeObserver = new ResizeObserver(update);
      this.storyResizeObserver.observe(track);
      update();
    }
    initResearch(options) {
      const research = this.querySelector('[data-research]');
      if (!research) return;
      const tabs = [...research.querySelectorAll('[data-research-tab]')];
      const panels = [...research.querySelectorAll('[data-research-panel]')];
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0;
      let visible = false;
      const stop = () => {
        this.researchAnimations?.forEach(animation => animation.cancel());
        this.researchAnimations = [];
      };
      const animate = () => {
        stop();
        if (!visible || motion.matches) return;
        this.researchAnimations = [...panels[current].querySelectorAll('.ns-research-bar')].map(bar => bar.animate([
          { transform: 'scaleY(0)' }, { transform: 'scaleY(1)' }
        ], { duration: 1100, easing: 'cubic-bezier(.2,.7,.2,1)' }));
      };
      const select = (index, announce = true) => {
        current = index;
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === current));
          tab.tabIndex = i === current ? 0 : -1;
          panels[i].hidden = i !== current;
        });
        if (announce) research.querySelector('[data-research-status]').textContent = panels[current].querySelector('figcaption p').textContent;
        animate();
      };
      tabs.forEach((tab, index) => {
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => { if (current !== index) select(index); }, options);
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(next);
          tabs[next].focus();
        }, options);
      });
      research.querySelector('[data-research-tabs]').hidden = false;
      select(0, false);
      if ('IntersectionObserver' in window) {
        this.researchObserver = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.3);
          if (visible) { animate(); this.researchObserver.disconnect(); }
        }, { threshold: [0, 0.3] });
        this.researchObserver.observe(research);
      } else visible = true;
      motion.addEventListener('change', stop, options);
    }
    initPurchase() {
    const listen = (node, name, fn) => node?.addEventListener(name, fn, {signal: this.controller.signal});
    const select = this.querySelector('[data-variant]');
    const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    const add = this.querySelector('.ns-add');
    const isEnglish = document.documentElement.lang.startsWith('en');
    const unitHandles = ['bio-grape-seed','bio-lingzhi','liveon','spi2ro-plus','glpro-core','tmk','imuglo','isoduce-plus','novia','erojan','homega','kuro-kosen'];
    const bottleHandles = ['bio-grape-seed','bio-lingzhi','spi2ro-plus','novia','erojan','homega'];
    const money = amount => new Intl.NumberFormat(isEnglish ? 'en-HK' : 'zh-HK', {style:'currency', currency:this.dataset.currency || 'HKD', minimumFractionDigits:0, maximumFractionDigits:2}).format(amount / 100);
    if (unitHandles.includes(this.dataset.handle)) {
      const packs = variants.filter(v => v.available && v.count > 0);
      if (packs.length > 1) {
        const lowest = Math.min(...packs.map(v=>v.price / v.count));
        const bottle = bottleHandles.includes(this.dataset.handle);
        const offer = this.querySelector('[data-catalog-offer]');
        offer.textContent = isEnglish ? `Multi-pack savings | From ${money(lowest)} per ${bottle?'bottle':'box'}` : `多買多平｜低至${money(lowest).replace('HK$','$')}一${bottle?'樽':'盒'}`;
        offer.hidden = false;
      }
      variants.forEach(v=>{const o=[...select.options].find(o=>o.value===String(v.id));if(o&&v.count>1)o.textContent+=isEnglish?` (${money(v.price/v.count)} each)`:`（每${bottleHandles.includes(this.dataset.handle)?'樽':'盒'} ${money(v.price/v.count).replace('HK$','$')}）`;});
    }
    const apply = (updateURL = true) => {
      const variant = variants.find(v => String(v.id) === select.value);
      if (!variant) return;
      this.querySelector('[data-price]').textContent = variant.money;
      add.disabled = !variant.available;
      add.textContent = variant.available ? this.dataset.add : this.dataset.sold;
      const detail = this.querySelector('[data-package-detail]');
      detail.textContent = this.dataset.handle === 'liveon' && this.dataset.servingDays && typeof variant.days === 'number' ? this.dataset.servingDays.replace('[days]', String(variant.days)) : variant.detail || (variant.days ? (typeof variant.days === 'number' ? `${variant.days} ${isEnglish ? 'days of servings' : '日份'}` : variant.days) : '');
      const unit = this.querySelector('[data-unit]');
      unit.hidden = !(unitHandles.includes(this.dataset.handle) && variant.count > 1);
      if (!unit.hidden) unit.textContent = (isEnglish ? (bottleHandles.includes(this.dataset.handle) ? 'Per bottle ' : 'Per box ') : (bottleHandles.includes(this.dataset.handle) ? '平均每樽 ' : '平均每盒 ')) + money(variant.price / variant.count);
      if (updateURL) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    };
    listen(select, 'change', () => apply());
    const pairHandles = ['tmk-imuglo-bundle','moveon-liveon-bundle'];
    if (pairHandles.includes(this.dataset.handle)) {
      const pairs = variants.map(v => { const n = [...v.title.matchAll(/(\d+)\s*盒/g)].map(x => Number(x[1])); return {...v, first:n[0], second:n[1]}; });
      if (pairs.every(v => Number.isInteger(v.first) && Number.isInteger(v.second))) {
        const first = this.querySelector('[data-pair="0"]'), second = this.querySelector('[data-pair="1"]');
        const initial = pairs.find(v => String(v.id) === select.value) || pairs[0];
        const option = value => new Option(isEnglish ? `${value} ${value === 1 ? 'box' : 'boxes'}` : `${value} 盒`, value);
        [...new Set(pairs.map(v => v.first))].sort((a,b)=>a-b).forEach(v => first.add(option(v)));
        first.value = initial.first;
        const updateSeconds = selected => {
          second.replaceChildren();
          [...new Set(pairs.filter(v => v.first === Number(first.value)).map(v => v.second))].sort((a,b)=>a-b).forEach(v => second.add(option(v)));
          if ([...second.options].some(o => o.value === String(selected))) second.value = selected;
        };
        updateSeconds(initial.second);
        const applyPair = () => {
          const match = pairs.find(v => v.first === Number(first.value) && v.second === Number(second.value));
          if (match) {select.value = match.id; apply();}
        };
        listen(first, 'change', () => {updateSeconds(second.value); applyPair();});
        listen(second, 'change', applyPair);
        this.querySelector('[data-variant-field]').hidden = true;
        this.querySelector('[data-pairs]').hidden = false;
      }
    }
    apply(false);
    listen(window, 'popstate', () => {
      const id = new URL(location.href).searchParams.get('variant');
      if (variants.some(v => String(v.id) === id)) {select.value = id; apply(false);}
    });
    }
    initDocuments(options) {
      const dialog = this.querySelector('[data-document-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const body = dialog.querySelector('[data-document-body]');
      const stack = dialog.querySelector('[data-document-pages]');
      const zoom = dialog.querySelector('[data-document-zoom]');
      const original = dialog.querySelector('[data-document-original]');
      let opener = null, previousOverflow = '';
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-open-document], [data-open-information]');
        if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const type = trigger.dataset.openDocument === 'flyer' ? 'flyer' : 'label';
        const template = this.querySelector(`[data-catalog-doc="${type}"]`);
        if (!template) return;
        opener = trigger;
        stack.replaceChildren(template.content.cloneNode(true));
        stack.querySelectorAll('img[data-src]').forEach(img => {img.src = img.dataset.src;img.removeAttribute('data-src');});
        const first = stack.querySelector('img');
        if (first) first.loading = 'eager';
        original.hidden = !first;
        if (first) original.href = first.src;
        stack.hidden = false;
        stack.classList.remove('is-zoomed');
        zoom.setAttribute('aria-pressed','false');
        body.classList.add('is-flyer');
        const title = type === 'flyer' ? dialog.dataset.flyerTitle : dialog.dataset.labelTitle;
        dialog.querySelector('[data-document-title]').textContent = title;
        dialog.querySelector('[data-document-status]').textContent = title;
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal();
        body.scrollTo({top:0,left:0,behavior:'instant'});
      }, options);
      this.querySelectorAll('[data-open-document], [data-open-information]').forEach(trigger => {
        trigger.setAttribute('aria-haspopup','dialog');trigger.setAttribute('aria-controls',dialog.id);trigger.setAttribute('role','button');
        trigger.addEventListener('keydown',event=>{if(event.key===' '){event.preventDefault();trigger.click();}},options);
      });
      dialog.querySelector('[data-document-close]').addEventListener('click',()=>dialog.close(),options);
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();},options);
      this.releaseDocument = () => {document.documentElement.style.overflow=previousOverflow;opener?.focus({preventScroll:true});};
      dialog.addEventListener('close',this.releaseDocument,options);
      zoom.addEventListener('click',()=>{const zoomed=stack.classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(zoomed));},options);
    }
    disconnectedCallback() {
      const documentDialog = this.querySelector('[data-document-dialog]');
      if (documentDialog?.open) { documentDialog.close(); this.releaseDocument?.(); }
      this.controller?.abort();
      this.controller = null;
      cancelAnimationFrame(this.stickyFrame);
      this.stickyFrame = null;
      this.stickyResizeObserver?.disconnect();
      if (this.sticky) {
        this.sticky.hidden = true;
        this.sticky.inert = true;
        this.sticky.classList.remove('is-visible');
        this.sticky.setAttribute('aria-hidden', 'true');
      }
      this.resizeObserver?.disconnect();
      this.compareResizeObserver?.disconnect();
      this.querySelector('[data-compare-scroll]')?.classList.remove('is-dragging');
      this.benefitResizeObserver?.disconnect();
      cancelAnimationFrame(this.benefitFrame);
      this.benefitFrame = null;
      this.querySelector('[data-benefit-timeline]')?.classList.remove('ns-benefit-timeline-enhanced');
      this.storyResizeObserver?.disconnect();
      this.bundleResizeObserver?.disconnect();
      cancelAnimationFrame(this.bundleFrame);
      this.bundleFrame = null;
      const bundle = this.querySelector('.ns-seed-bundle');
      bundle?.classList.remove('ns-bundle-scroll-motion');
      bundle?.style.removeProperty('--ns-bundle-scale');
      bundle?.style.removeProperty('--ns-bundle-radius');
      this.packObserver?.disconnect();
      clearTimeout(this.packAutoTimer);
      this.packAutoTimer = null;
      this.packShake?.cancel();
      this.querySelector('.ns-pack-card')?.classList.remove('ns-pack-motion', 'ns-pack-visible');
      this.researchObserver?.disconnect();
      this.researchAnimations?.forEach(animation => animation.cancel());
      this.querySelector('[data-research-tabs]')?.setAttribute('hidden', '');
      this.querySelectorAll('[data-research-panel]').forEach(panel => { panel.hidden = false; panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); panel.removeAttribute('tabindex'); });
    }
  });
}



